import { render, staticRenderFns } from "./CustomerPageTrainingsList.vue?vue&type=template&id=24d184bc&"
import script from "./CustomerPageTrainingsList.vue?vue&type=script&lang=js&"
export * from "./CustomerPageTrainingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports